import { RefreshCcw } from 'lucide-react';
import { useState } from 'react';

type Props = {
  disabled?: boolean;
  className?: string;
};

export default function TimeInput({ disabled, className }: Props) {
  const [value, setValue] = useState('');

  const reset = () => setValue('');

  return (
    <div className="flex items-center gap-2 w-full">
      <div className="relative w-full">
        <input
          type="time"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          disabled={disabled}
          className={className}
        />

        {/* Powered text */}
        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-[#621C43] opacity-70 pointer-events-none">
          Powered by Bluenumber®
        </span>
      </div>

      <button type="button" onClick={reset} className="text-[#7a3a4c]">
        <RefreshCcw size={18} />
      </button>
    </div>
  );
}
